import { cn, Gallery } from '@divlab/divanui';
import { Children } from 'react';

import chunkArray from '@Utils/chunkArray';
import styles from './CatalogGallery.module.css';

import type { FC, HTMLAttributes, PropsWithChildren } from 'react';

interface GalleryProps extends HTMLAttributes<HTMLDivElement>, PropsWithChildren {
  itemsCountInSlide: number;
  grid: [columns: number, rows: number];
}

const CatalogGallery: FC<GalleryProps> = (props) => {
  const { className, children, itemsCountInSlide, grid, ...restProps } = props;
  const childrenSlides = chunkArray(Children.toArray(children), itemsCountInSlide);

  return (
    <Gallery
      className={cn(styles.wrapper, className)}
      cnSlide={styles.slide}
      scrollbar
      {...restProps}
    >
      {childrenSlides.map((childrenSlide, index) => (
        <div key={index}>
          <div
            className={styles.grid}
            style={{
              gridTemplate: `repeat(${grid[1]}, auto) / repeat(${grid[0]}, minmax(140px, 1fr))`,
            }}
          >
            {childrenSlide}
          </div>
        </div>
      ))}
    </Gallery>
  );
};
export default CatalogGallery;
